import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestStorageRegisterEdit from './request/requestStorageRegisterEdit'

const Actions = {
  // ST01 倉庫一覧取得
  getStorageListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.STORAGE_LIST)
      .get(api.STORAGE_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.STORAGE_SET_STORAGE_LIST
        commit(path, response.data.data)

        const getData = getters.getStorageListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        // TODO: APIエラー時共通処理
        // alert('倉庫一覧取得失敗')
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // ST02 倉庫登録・編集
  registerEditStorage: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestStorageRegisterEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.STORAGE_REGISTER_EDIT)
      .post(api.STORAGE_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // IT07 在庫一覧CSVダウンロード
  csvDownloadStockList: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    return await axios
      .get(api.STORAGE_PRODUCT_STOCK_LIST, {
        params
      })
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // LS13 在庫調整用商品一覧CSV出力
  getStockAdjustProductListCsv: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    return await axios
      .get(api.STOCK_ADJUST_PRODUCT_LIST_CSV, {
        params
      })
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
